


<div class="page-content">
<nbc-alert [class.d-none]="!showOnboardingReportAlert"></nbc-alert>
    <accordion close-others="toggleAtATime">
      <accordion-group *ngFor=" let report of reports"
                       [(isOpen)]="isAccordionOpen">
        <span accordion-heading>
          <i class="fa fa-caret-right"
             [ngClass]="isAccordionOpen ? 'fa-sort-down':'fa-caret-right'"></i> <span class="text-dark">{{report.title}}</span>
          <span class="report-count">({{report.count}})</span>
        </span>
        <div class="row report-panel">
          <div class="top-no-border"></div>
          <div *ngFor="let item of report.items"
               class="col-md-12">
            <div class="report-item">
              {{item.name}}
              <span class="report-btn">
                <!-- @*<a ng-class="item.isExport? 'btn btn-secondary' : 'btn btn-secondary'" ng-hide="item.isExport=='false'" ng-click=" Export(item.name);">Export</a>*@ -->
                <a class="btn btn-primary"
                   [ngClass]="{hasHidden: item.isNotCustomize=='true'}"
                   (click)="customizeReportModal(item.name)"
                   authenticate-user="TPMReports.Retrieve">
                  Export ...
                </a>
              </span>
            </div>
          </div>
        </div>
      </accordion-group>
    </accordion>
</div>
<app-nbc-file-download *ngIf="isDownload"></app-nbc-file-download>
